import { useTrip } from "@/lib/store";
import { CalendarButton } from "@/components/CalendarButton";
import { TRIP_DATES, fmtLong } from "@/lib/dates";
import { SubHeader } from "../More";

export default function CalendarPage() {
  const { trip } = useTrip();
  return (
    <div className="pb-8">
      <SubHeader eyebrow="Calendar" title="Take the trip with you" />
      <p className="mt-2 text-sm text-[var(--ink-muted)]">Files work with Apple Calendar, Outlook, Google and any app that accepts .ics. Items without a time are added as all-day events — no times are invented.</p>
      <div className="card-soft mt-4 p-4">
        <p className="eyebrow">Whole trip</p>
        <p className="mt-1 text-sm">{trip.hotels.length} stays · {trip.transports.length} journeys · {trip.events.length} planned items</p>
        <div className="mt-3"><CalendarButton kind="trip" item={null} label="Add entire trip" testId="calendar-entire-trip-btn" /></div>
      </div>
      <p className="eyebrow mt-6 mb-2">Hotel stays</p>
      <div className="space-y-2">{trip.hotels.map((h) => <div key={h.id} className="card-soft flex items-center justify-between gap-3 p-3"><div><p className="font-semibold">{h.name}</p><p className="text-xs text-[var(--ink-muted)]">{h.city} · {h.nights} nights</p></div><CalendarButton kind="hotel" item={h} label="Add stay" compact testId={`calendar-page-hotel-${h.id}`} /></div>)}</div>
      <p className="eyebrow mt-6 mb-2">Days</p>
      <div className="space-y-2">{TRIP_DATES.map((d) => <div key={d} className="card-soft flex items-center justify-between gap-3 p-3"><div><p className="font-semibold">{fmtLong(d)}</p><p className="text-xs text-[var(--ink-muted)]">{trip.days.find((x) => x.date === d)?.city}</p></div><CalendarButton kind="day" item={d} label="Add day" compact testId={`calendar-page-day-${d}`} /></div>)}</div>
    </div>
  );
}
